export default [
  {
    path: '/reports',
    component: () => import('@/views/reports/ReportsPage.vue'),
    meta: { 
      title:'Reports',
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'reports_dashboard',
    },
  }
]